export default __webpack_public_path__ + "static/media/neu.4f2cf228.png";